import { ErrorMessage, Field } from "formik";

interface FormInputProps {
  nameAndId: string;
  label: string;
  placeholder: string;
  type?: "text" | "number" | "email" | "password" | "tel" | "file";
  className?: string;
  labelClassName?: string;
  accept?: string;
}

function GroupFormInput({
  nameAndId,
  label,
  placeholder,
  type,
  accept,
  className,
  labelClassName
}: FormInputProps) {
  return (
    <div className="flex flex-col">
      <label
        className={`text-white md:text-2xl text-base font-bold pb-3 ${labelClassName ?? ""}`}
        htmlFor={nameAndId}
      >
        <span className="">{label}</span>
      </label>

      <Field
        name={nameAndId}
        id={nameAndId}
        placeholder={placeholder}
        type={type ?? "text"}
        accept={accept}
        className={
          className ??
          "bg-green placeholder-gray text-white md:text-2xl text-base font-normal p-1 md:h-[73px] h-[44px] focus:ring-0 border-2 border-gray rounded-md outline-none"
        }
      />

      <ErrorMessage component="label" name={nameAndId} className="text-sm w-full text-[#FF0000]" />
    </div>
  );
}

export default GroupFormInput;
